export default __webpack_public_path__ + "static/media/numbers-mobile.f9611205.jpg";